import { FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import { popupName } from 'constants/auth/auth-data'
import { buttonIdNavbarLogin } from 'constants/clickableElementsId'
import { cutHashFromURL } from 'utils/getURLData'
import { PROMO_REDIRECT_URL } from 'constants/data'

import style from './navbar-right-side.module.scss'
interface INavbarNoAuth {
  congressTheme?: boolean
  studentsTheme?: boolean
  isNoAuth?: boolean
}

const NavbarNoAuth: FC<INavbarNoAuth> = ({ congressTheme, studentsTheme, isNoAuth }) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  const loginHref = `${path}#${popupName.registration}`

  if (isNoAuth)
    return (
      <Link
        href={PROMO_REDIRECT_URL}
        className={style.buttonLogin}
        onClick={() => {
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        }}
      >
        На главную
      </Link>
    )

  return (
    <>
      {!studentsTheme && (
        <Link
          className={clsx(style.buttonLogin, {
            [style.congressLogin]: congressTheme,
          })}
          id={buttonIdNavbarLogin}
          href={loginHref}
        >
          Войти в аккаунт
        </Link>
      )}
    </>
  )
}

export default NavbarNoAuth
